import type { StyleRule } from '@archipro-design/aria';

export const ProjectPlacementContainer: StyleRule<{ columns: number }> = ({
    columns,
}) => {
    return {
        gridColumn: `1/${columns + 1}`,
    };
};
